module.exports = __webpack_public_path__ + "static/media/certificate-icon-1.4b60d773.png";